export const WHATSAPP_NUMBER = "5491151558102";
export const WHATSAPP_PRETTY = "+54 9 11 5155 8102";

export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const generalMsg = () =>
  "Hola MM Store! Vengo de la web y quiero hacer una consulta.";

export const productMsg = (name, size) =>
  `Hola MM Store! Quiero consultar sobre ${name}${size ? ` en talle ${size}` : ""}.`;

const unitPrice = (i) => i.price ?? i.unit_price ?? 0;

export const cartMsg = (items, totals) => {
  const lines = items
    .map(
      (i) =>
        `• ${i.qty}x ${i.name}${i.size ? ` (talle ${i.size})` : ""} — $${(
          unitPrice(i) * i.qty
        ).toLocaleString("es-AR")}`
    )
    .join("\n");
  const discount =
    totals.discount > 0
      ? `\n\nDescuento 2da prenda (10% OFF): -$${totals.discount.toLocaleString("es-AR")}`
      : "";
  return `Hola MM Store! Quiero comprar:\n\n${lines}\n\nSubtotal: $${totals.subtotal.toLocaleString(
    "es-AR"
  )}${discount}\nTOTAL: $${totals.total.toLocaleString("es-AR")}`;
};

export const orderMsg = (order, buyer) => {
  const totals = { subtotal: order.subtotal, discount: order.discount, total: order.total };
  return `Hola MM Store! Acabo de registrar un pedido:\n\nPedido: ${order.order_id}\nNombre: ${buyer.name}\nTeléfono: ${buyer.phone}\nDirección: ${buyer.address}, ${buyer.city}\n\n${cartMsg(
    order.items,
    totals
  )}`;
};
